mutation StartCameraControl($camControlId: ID!) {
  camControl: StreamToolsStartCameraControl(camControlId: $camControlId) {
    camControlId
    status
    startedAt
    stoppedAt
    version
    currentCommandIndex
    streak
  }
}
